import { OpcaoMenu } from '../../../shared/menus/opcao-menu.interface';

const tituloMenuLateralPrecoEncargosAdicionais = '5. Preços, encargos e adicionais';
const caminhoImagemLateralPrecoEncargosAdicionais = '../../../assets/icone-precos-encargos-adicionais.svg';
const corFundoLateralPrecoEncargosAdicionais = '#e63d25';

const opcoesMenusLateralAtivasPrecoEncargosAdicionais: OpcaoMenu[] = [
  {
    rotulo: 'Direitos e obrigações trabalhistas',
    caminho: '/condicao-qualidade/direitos-obrigacoes-trabalhistas',
    selecionado: false,
  },
  {
    rotulo: 'Docente: adicional de remuneração',
    caminho: '/condicao-qualidade/docente-adicional-remuneracao',
    selecionado: false,
  },
];

const opcoesMenuLateralPrecoEncargosAdicionaisInativas: OpcaoMenu[] = [
  { rotulo: 'Índices de preços', caminho: '#' },
  { rotulo: 'Tabela de preços', caminho: '#' },
];

export {
  opcoesMenusLateralAtivasPrecoEncargosAdicionais,
  opcoesMenuLateralPrecoEncargosAdicionaisInativas,
  tituloMenuLateralPrecoEncargosAdicionais,
  caminhoImagemLateralPrecoEncargosAdicionais,
  corFundoLateralPrecoEncargosAdicionais,
};
